module.exports = __webpack_public_path__ + "img/08.2b2366d0.jpg";